import { Vue, Component } from 'vue-property-decorator';

export type BaseRef = { [key: string]: Element };

export interface EmitType {
  [key: string]: any[] | any
}

@Component
class BaseVue<R extends BaseRef = {}, E extends EmitType = {}> extends Vue {
  public $refs: R = {} as any;

  constructor(...args: any[]) {
    super(args);
    this.$refs = { ...super.$refs as R };
  }

  public emit<K extends keyof E>(e: K, ...args: E[K]): this {
    if (args.length === 0) {
      super.$emit(e as string, {});
    } else {
      super.$emit(e as string, ...args as IArguments);
    }
    return this;
  }
}

export default BaseVue;
